import { ref } from 'vue';
import { v4 } from 'uuid';

export default function useSubscriptionManager() {
  const subscriptions = ref({});
  const addSubscriber = (unsubscribe, options) => {
    subscriptions.value[v4()] = { unsubscribe, options };
  };

  const unsubscribeAll = (filter = () => true) => {
    Object.keys(subscriptions.value).forEach((key) => {
      if (!filter(subscriptions.value[key])) {
        return;
      }
      subscriptions.value[key].unsubscribe();
      delete subscriptions.value[key];
    });
  };

  return {
    addSubscriber,
    unsubscribeAll,
  };
}
